import styled from 'styled-components'

export const GlobalSearchLoadingContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: ${(props) => props.theme.typography.pxToRem(48)};
  padding: ${(props) => props.theme.typography.pxToRem(4)} 0;
  min-width: 0;
`
